/**
 * §P.3 + §P.4 · El marco de «Cobros»: las pestañas y nada más.
 *
 * Cinco pantallas bajo una sección porque son **un solo trabajo**: lo que hace el
 * administrativo la primera semana de mes —mirar quién debe, emitir la remesa,
 * anotar lo que entra— más lo que se toca dos veces al año, las tarifas y los
 * descuentos. El porqué de agruparlas está en `club/secciones.ts`.
 *
 * Esto era `Cobros.tsx` con una cadena de `switch`. Ahora cada pestaña es una ruta
 * de verdad —`/cobros/morosos` en lugar de `?seccion=cobros&vista=morosos`— y lo
 * que queda aquí es la barra.
 */
import { Link, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { VISTAS_DE_COBROS } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';
import { puedeVerCuota } from '@/club/permisos';

export function MarcoDeCobros() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  /*
   * **El guardián del dinero**, y está aquí porque al meter el enrutador se perdió.
   *
   * Antes lo hacía `aSeccion(valor, rol)`: un `?seccion=cobros` reenviado por
   * WhatsApp al entrenador del club le abría el panel y no un `403`. Con rutas de
   * verdad, `/cobros/recibos` se puede escribir en la barra, así que la
   * comprobación tiene que seguir existiendo — en un solo sitio, que es este marco,
   * y no repetida en las cinco pestañas.
   *
   * `replace` para que «atrás» no devuelva aquí y deje al entrenador rebotando.
   */
  if (!puedeVerCuota(rol)) return <Navigate to="/alumnos" replace />;

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de cobros">
        {VISTAS_DE_COBROS.map((v) => {
          const destino = `/cobros/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              /*
               * `startsWith` y no igualdad, igual que en el menú de arriba: dentro
               * de `/cobros/recibos/01a0…` la pestaña «Recibos» sigue marcada. Con
               * igualdad, abrir un recibo apaga la pestaña y nadie sabe dónde está.
               */
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
